var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:star-broken"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.02747 5.18101C2.38747 5.55234 1.56747 5.73768 1.37214 6.36501C1.17747 6.99168 1.73614 7.64568 2.85414 8.95301L3.14347 9.29101C3.46081 9.66234 3.62014 9.84834 3.69147 10.0777C3.76281 10.3077 3.73881 10.5557 3.69081 11.051L3.64681 11.5023C3.47814 13.247 3.39347 14.119 3.90414 14.5063C4.41481 14.8943 5.18281 14.5403 6.71747 13.8337L7.11547 13.651C7.55147 13.4497 7.76947 13.3497 8.00081 13.3497C8.23214 13.3497 8.45014 13.4497 8.88681 13.651L9.28347 13.8337C10.8188 14.5403 11.5868 14.8937 12.0968 14.507C12.6081 14.119 12.5235 13.247 12.3548 11.5023M13.1475 8.95301C14.2655 7.64634 14.8241 6.99234 14.6295 6.36501C14.4341 5.73768 13.6141 5.55167 11.9741 5.18101L11.5501 5.08501C11.0841 4.97967 10.8515 4.92701 10.6641 4.78501C10.4775 4.64301 10.3575 4.42767 10.1175 3.99701L9.89881 3.60501C9.05414 2.09034 8.63214 1.33301 8.00081 1.33301C7.36947 1.33301 6.94747 2.09034 6.10281 3.60501",
    stroke: "black",
    strokeWidth: 0.625,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.984dae9a8b9d66fcb2ce0ad12f3ae0fa.svg";
export { ForwardRef as ReactComponent };